!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((n = n || self).blobs2 = {});
}(this, function (n) {
  "use strict";

  function i(n) {
    var t,
        e,
        r,
        o,
        i = function (n) {
      for (var t = 2166136261, e = 0; e < n.length; e++) {
        t = Math.imul(t ^ n.charCodeAt(e), 16777619);
      }

      return function () {
        return t += t << 13, t ^= t >>> 7, t += t << 3, t ^= t >>> 17, (t += t << 5) >>> 0;
      };
    }(n);

    return t = i(), e = i(), r = i(), o = i(), function () {
      var n = (t >>>= 0) + (e >>>= 0) | 0;
      return t = e ^ e >>> 9, e = (r >>>= 0) + (r << 3) | 0, r = (r = r << 21 | r >>> 11) + (n = n + (o = 1 + (o >>>= 0) | 0) | 0) | 0, (n >>> 0) / 4294967296;
    };
  }

  function o(n) {
    return {
      x: n.x,
      y: n.y,
      handleIn: _t({}, n.handleIn),
      handleOut: _t({}, n.handleOut)
    };
  }

  function r(e, r) {
    for (var n = function n(_n) {
      function t(n) {
        return o(e[c(n, e.length)]);
      }

      r({
        curr: o(e[_n]),
        index: _n,
        sibling: t,
        prev: function prev() {
          return t(_n - 1);
        },
        next: function next() {
          return t(_n + 1);
        }
      });
    }, t = 0; t < e.length; t++) {
      n(t);
    }
  }

  function u(n, t) {
    var e = [];
    return r(n, function (n) {
      e.push(t(n));
    }), e;
  }

  function a(n, t) {
    return {
      x: n.x + t.length * Math.cos(t.angle),
      y: n.y + t.length * Math.sin(t.angle)
    };
  }

  function f(n, l) {
    return u(n, function (n) {
      var t,
          e,
          r,
          o,
          i,
          u = n.curr,
          a = n.next,
          s = n.prev,
          f = (t = s(), e = a(), r = e.x - t.x, o = -e.y + t.y, (i = Math.atan2(o, r)) < 0 ? Math.abs(i) : 2 * Math.PI - i);
      return {
        x: u.x,
        y: u.y,
        handleIn: {
          angle: f + Math.PI,
          length: l * d(u, s())
        },
        handleOut: {
          angle: f,
          length: l * d(u, a())
        }
      };
    });
  }

  function s(n) {
    var t = i(String(n.seed)),
        e = 1 / (1 + n.randomness / 10),
        r = function (n, t) {
      for (var e = 2 * Math.PI / n, r = [], o = 0; o < n; o++) {
        var i = t(),
            u = Math.sin(o * e),
            a = Math.cos(o * e);
        r.push({
          x: .5 + u * i,
          y: .5 + a * i,
          handleIn: {
            angle: 0,
            length: 0
          },
          handleOut: {
            angle: 0,
            length: 0
          }
        });
      }

      var s = 4 / 3 * Math.tan(e / 4) / Math.sin(e / 2) / 2;
      return f(r, s);
    }(3 + n.extraPoints, function () {
      return (e + t() * (1 - e)) / 2;
    }),
        o = n.size;

    return u(r, function (n) {
      var t = n.curr;
      return t.x *= o, t.y *= o, t.handleIn.length *= o, t.handleOut.length *= o, t;
    });
  }

  function l(n, t, e) {
    var r = typeof t;
    if ("number" === r && isNaN(t) && (r = "NaN"), "object" === r && null === t && (r = "null"), !e.includes(r)) throw '"' + n + '" should have type "' + e.join("|") + '" but was "' + r + '".';
  }

  function h(n) {
    l("blobOptions", n, ["object"]);
    var t = n.seed,
        e = n.extraPoints,
        r = n.randomness,
        o = n.size;
    if (l("blobOptions.seed", t, ["string", "number"]), l("blobOptions.extraPoints", e, ["number"]), e < 0) throw 'blobOptions.extraPoints is invalid "' + e + '".';
    if (l("blobOptions.randomness", r, ["number"]), r < 0) throw 'blobOptions.randomness is invalid "' + r + '".';
    if (l("blobOptions.size", o, ["number"]), o < 0) throw 'blobOptions.size is invalid "' + o + '".';
  }

  var _t = function t() {
    return (_t = Object.assign || function (n) {
      for (var t, e = 1, r = arguments.length; e < r; e++) {
        for (var o in t = arguments[e]) {
          Object.prototype.hasOwnProperty.call(t, o) && (n[o] = t[o]);
        }
      }

      return n;
    }).apply(this, arguments);
  },
      c = function c(n, t) {
    return (n % t + t) % t;
  },
      d = function d(n, t) {
    return Math.sqrt(Math.pow(n.x - t.x, 2) + Math.pow(n.y - t.y, 2));
  },
      v = function v(n) {
    try {
      h(n);
    } catch (n) {
      throw "(blobs2): " + n;
    }

    return t = s(n), i = "M" + t[0].x + "," + t[0].y, r(t, function (n) {
      var t = n.curr,
          e = (0, n.next)(),
          r = a(t, t.handleOut),
          o = a(e, e.handleIn);
      i += "C" + r.x + "," + r.y + "," + o.x + "," + o.y + "," + e.x + "," + e.y;
    }), i;
    var t, i;
  };

  n.canvasPath = function (n, e) {
    void 0 === e && (e = {});

    try {
      h(n), function (n) {
        if (l("canvasOptions", n, ["object", "undefined"]), n) {
          var t = n.offsetX,
              e = n.offsetY;
          l("canvasOptions.offsetX", t, ["number", "undefined"]), l("canvasOptions.offsetY", e, ["number", "undefined"]);
        }
      }(e);
    } catch (n) {
      throw "(blobs2): " + n;
    }

    return t = u(s(n), function (n) {
      var t = n.curr;
      return t.x += e.offsetX || 0, t.y += e.offsetY || 0, t;
    }), i = new Path2D(), t.length < 1 || (i.moveTo(t[0].x, t[0].y), r(t, function (n) {
      var t = n.curr,
          e = (0, n.next)(),
          r = a(t, t.handleOut),
          o = a(e, e.handleIn);
      i.bezierCurveTo(r.x, r.y, o.x, o.y, e.x, e.y);
    })), i;
    var t, i;
  }, n.svg = function (n, t) {
    void 0 === t && (t = {});

    try {
      h(n), function (n) {
        if (l("svgOptions", n, ["object", "undefined"]), n) {
          var t = n.fill,
              e = n.stroke,
              r = n.strokeWidth;
          l("svgOptions.fill", t, ["string", "undefined"]), l("svgOptions.stroke", e, ["string", "undefined"]), l("svgOptions.strokeWidth", r, ["number", "undefined"]);
        }
      }(t);
    } catch (n) {
      throw "(blobs2): " + n;
    }

    var e = v(n),
        r = Math.floor(n.size),
        o = void 0 === t.fill ? "#ec576b" : t.fill;
    return ('\n<svg width="' + r + '" height="' + r + '" viewBox="0 0 ' + r + " " + r + '" xmlns="http://www.w3.org/2000/svg">\n    <path stroke="' + (void 0 === t.stroke ? "none" : t.stroke) + '" stroke-width="' + (void 0 === t.strokeWidth ? 0 : t.strokeWidth) + '" fill="' + o + '" d="' + e + '"/>\n</svg>').trim();
  }, n.svgPath = v, Object.defineProperty(n, "__esModule", {
    value: !0
  });
});